// 动态加载axios，如果npm安装失败则使用CDN
let axios

if (typeof window !== 'undefined' && window.axios) {
  // 使用CDN引入的axios
  axios = window.axios
} else {
  try {
    // 尝试使用npm安装的axios
    axios = require('axios')
  } catch (e) {
    // 如果都失败，创建空对象避免报错
    console.error('Axios未安装，请在web目录运行: npm install axios')
    axios = {
      create: () => ({
        get: () => Promise.reject({ message: 'Axios未安装' }),
        post: () => Promise.reject({ message: 'Axios未安装' }),
        put: () => Promise.reject({ message: 'Axios未安装' }),
        delete: () => Promise.reject({ message: 'Axios未安装' }),
        interceptors: { request: { use: () => {}, eject: () => {} }, response: { use: () => {}, eject: () => {} } }
      })
    }
  }
}

import config from '@/config'

// 创建axios实例
const instance = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 如果有token，添加认证头
    const token = localStorage.getItem('admin-token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response) {
      // 后端返回了错误响应
      const { data, status } = error.response
      
      if (status === 401) {
        // 未授权，跳转到登录页
        localStorage.removeItem('admin-token')
        window.location.href = '/login'
      }
      
      return Promise.reject({
        message: data.message || '请求失败',
        code: data.code || status,
        data: data.data
      })
    } else if (error.request) {
      // 请求已发出但没有收到响应
      return Promise.reject({
        message: '网络错误，请检查后端服务是否运行',
        code: 'NETWORK_ERROR'
      })
    } else {
      // 其他错误
      return Promise.reject({
        message: error.message,
        code: 'UNKNOWN_ERROR'
      })
    }
  }
)

// API服务
export const api = {
  // 管理员相关
  admin: {
    login: (data) => instance.post('/admin/login', data),
    info: () => instance.get('/admin/info'),
    logout: () => instance.post('/admin/logout'),
    update: (data) => instance.put('/admin/update', data)
  },

  // 仪表盘
  dashboard: {
    index: () => instance.get('/dashboard/index'),
    studyTrend: () => instance.get('/dashboard/studyTrend')
  },

  // 栏目管理
  category: {
    list: () => instance.get('/category'),
    get: (id) => instance.get(`/category/${id}`),
    create: (data) => instance.post('/category', data),
    update: (id, data) => instance.put(`/category/${id}`, data),
    delete: (id) => instance.delete(`/category/${id}`)
  },

  // 签到记录
  checkin: {
    list: (params) => instance.get('/study-checkin', { params }),
    get: (id) => instance.get(`/study-checkin/${id}`),
    delete: (id) => instance.delete(`/study-checkin/${id}`)
  },

  // 用户管理
  user: {
    list: (params) => instance.get('/user', { params }),
    get: (id) => instance.get(`/user/${id}`),
    create: (data) => instance.post('/user', data),
    update: (id, data) => instance.put(`/user/${id}`, data),
    delete: (id) => instance.delete(`/user/${id}`),
    records: (id) => instance.get(`/user/${id}/records`)
  },

  // 视频管理
  video: {
    list: () => instance.get('/video'),
    get: (id) => instance.get(`/video/${id}`),
    create: (data) => instance.post('/video', data),
    update: (id, data) => instance.put(`/video/${id}`, data),
    delete: (id) => instance.delete(`/video/${id}`)
  },

  // 测验题管理
  quiz: {
    list: (params) => instance.get('/quiz', { params }),
    get: (id) => instance.get(`/quiz/${id}`),
    create: (data) => instance.post('/quiz', data),
    update: (id, data) => instance.put(`/quiz/${id}`, data),
    delete: (id) => instance.delete(`/quiz/${id}`)
  },

  // 学习记录
  studyRecord: {
    list: (params) => instance.get('/studyRecord', { params }),
    get: (id) => instance.get(`/studyRecord/${id}`),
    create: (data) => instance.post('/studyRecord', data),
    update: (id, data) => instance.put(`/studyRecord/${id}`, data),
    delete: (id) => instance.delete(`/studyRecord/${id}`)
  },

  // 隐患排查
  inspectItem: {
    list: (params) => instance.get('/inspectItem', { params }),
    get: (id) => instance.get(`/inspectItem/${id}`),
    create: (data) => instance.post('/inspectItem', data),
    update: (id, data) => instance.put(`/inspectItem/${id}`, data),
    delete: (id) => instance.delete(`/inspectItem/${id}`)
  }
}

export default instance
